@if ({
  pagesGrid: pagesGrid$ | async,
  }; as content) {
  @if (content?.pagesGrid?.pages?.length) {
    <div class="container-content-page-grid">
      <div class="container">
        <div class="box-titles">
          @if (content.pagesGrid?.line1) {
            <p class="line-1">{{ content.pagesGrid?.line1 }}</p>
          }
          @if (content.pagesGrid?.line2) {
            <p class="line-2">{{ content.pagesGrid?.line2 }}</p>
          }
        </div>
        <div class="cards" [ngClass]="'container-of-' + (content?.pagesGrid?.pages)!.length">
          @for (page of content?.pagesGrid?.pages; track page) {
            <div class="card">
              <a [routerLink]="page.label">
                <img [src]="page.previewImage?.url" alt="" />
              </a>
              <a class="line-1" [routerLink]="page.label">
                {{ page.line1 }}
              </a>
              <div class="content m-t-20 line-2" [innerHTML]="page.line2"></div>
            </div>
          }
        </div>
      </div>
    </div>
  }
}
